export const BOTAO_CLICADO_SUCCESS = 'BOTAO_CLICADO_SUCCESS';
export const BOTAO_CLICADO_REQUEST = 'BOTAO_CLICADO_REQUEST';
export const BOTAO_CLICADO_FAILURE = 'BOTAO_CLICADO_FAILURE';

export const LOGIN_REQUEST = 'LOGIN_REQUEST';
export const LOGIN_SUCCESS = 'LOGIN_SUCCESS';
export const LOGIN_FAILURE = 'LOGIN_FAILURE';
export const LOGIN_LOADING = 'LOGIN_LOADING'; // Adicionada esta linha
export const LOGOUT = 'LOGOUT';

export const PERSIST_REHYDRATE = 'persist/REHYDRATE';
